import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo/LogoYellow.svg'
import _imports_1 from '@/assets/icons/Android.svg'
import _imports_2 from '@/assets/images/LoginImage.png'


const _hoisted_1 = { class: "wrapper-login" }
const _hoisted_2 = { class: "wrapper-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginButton = _resolveComponent("LoginButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logo"
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_1,
          alt: "",
          class: "icon"
        }, null, -1)),
        _createElementVNode("a", {
          href: _ctx.route,
          class: "wrapper-button"
        }, [
          _createVNode(_component_LoginButton, { buttonLabel: 'Descarga nuestra app' })
        ], 8, _hoisted_4)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wrapper-image" }, [
      _createElementVNode("img", {
        src: _imports_2,
        alt: "",
        class: "image"
      })
    ], -1))
  ]))
}